import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { utils, translations } from 'gipsy-misc';
import WatcherAndReviewer from '../../components/WatcherAndReviewer';
import ReviewInputLink from '../ReviewInputLink';
import injected from '../../../injected';

var Reviewer = function (_PureComponent) {
  _inherits(Reviewer, _PureComponent);

  function Reviewer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Reviewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Reviewer.__proto__ || Object.getPrototypeOf(Reviewer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hideDefaultBehavior: true,
      wasInjectedUserSelected: false
    }, _this.onSelect = function (e, _ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value;

      var allWatchers = _this.props.value;
      var indexInWatchers = utils.array.getObjectIndexInArrayMatchingAtLeastOneField(allWatchers, value, ['userId', 'email']);
      var injectedUser = { userId: injected.user.id };
      if (indexInWatchers === -1) {
        if (utils.user.areSameUser(injectedUser, value)) {
          _this.setState({ wasInjectedUserSelected: true });
        }
        _this.props.onChange({ paramName: paramName, value: _extends({}, value, { isReviewer: true }), method: 'add' });
      } else if (allWatchers[indexInWatchers] && !allWatchers[indexInWatchers].isReviewer) {
        if (utils.user.areSameUser(injectedUser, value)) {
          _this.setState({ wasInjectedUserSelected: true });
        }
        _this.props.onChange({ paramName: paramName, value: _extends({}, value, { isReviewer: true }), method: 'makeReviewer' });
      } else if (allWatchers[indexInWatchers] && allWatchers[indexInWatchers].isReviewer) {
        if (utils.user.areSameUser(injectedUser, value)) {
          _this.setState({ wasInjectedUserSelected: false, hideDefaultBehavior: false });
        }
        _this.props.onChange({ paramName: paramName, value: _extends({}, value, { isReviewer: false }), method: 'remove' });
      }
    }, _this.onClickDefaultBehavior = function () {
      var injectedUser = { userId: injected.user.id };
      var allReviewers = _this.props.value;
      var indexInWatchers = utils.array.getObjectIndexInArrayMatchingAtLeastOneField(allReviewers, injectedUser, ['userId', 'email']);

      if (indexInWatchers !== -1) {
        injectedUser = allReviewers[indexInWatchers];
        _this.props.onChange({
          paramName: 'watchers',
          value: _extends({}, injectedUser, { isReviewer: false }),
          method: 'removeReviewer'
        });
      }
    }, _this.onCloseDefaultBehavior = function () {
      _this.setState({ hideDefaultBehavior: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Reviewer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.mode === 'create') {
        this.setState({ hideDefaultBehavior: false });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var injectedUser = { userId: injected.user.id };
      if (utils.user.areSameUser(injectedUser, prevProps.to) && !utils.user.areSameUser(prevProps.to, this.props.to)) {
        this.setState({ hideDefaultBehavior: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          id = _props.id,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          toggleField = _props.toggleField,
          deactivateField = _props.deactivateField,
          value = _props.value,
          defaultContacts = _props.defaultContacts,
          mode = _props.mode,
          reviewInputLinkValue = _props.reviewInputLinkValue,
          review = _props.review;

      var reviewers = value.filter(function (w) {
        return w.isReviewer;
      }).reverse();

      var injectedUser = { userId: injected.user.id };

      var showDefaultBehavior = !this.state.hideDefaultBehavior && !this.state.wasInjectedUserSelected && utils.array.getObjectIndexInArrayMatchingAtLeastOneField(reviewers, injectedUser, ['userId', 'email']) !== -1;

      var hasReviewInPanel = !!review;
      var showReviewInputLink = reviewers && reviewers.length > 0 && !showDefaultBehavior && !hasReviewInPanel;

      return React.createElement(
        Fragment,
        null,
        React.createElement(WatcherAndReviewer, {
          to: to,
          id: id,
          isActive: isActive,
          isOpen: isOpen,
          deactivateField: deactivateField,
          toggleField: toggleField,
          onSelect: this.onSelect,
          value: reviewers,
          defaultContacts: defaultContacts,
          title: utils.string.capitalize(translations.general.reviewers),
          icon: 'Star',
          showStar: true,
          defautBehaviorMessage: translations.taskPanel.reviewers.defautBehaviorMessage,
          defautBehaviorActionMessage: translations.taskPanel.reviewers.defautBehaviorActionMessage,
          onClickDefaultBehavior: this.onClickDefaultBehavior,
          showDefaultBehavior: showDefaultBehavior,
          onCloseDefaultBehavior: this.onCloseDefaultBehavior
        }),
        showReviewInputLink && React.createElement(ReviewInputLink, {
          id: 'reviewInputLink',
          mode: mode,
          onChange: this.props.onChange,
          value: reviewInputLinkValue
        })
      );
    }
  }]);

  return Reviewer;
}(PureComponent);

Reviewer.propTypes = {
  mode: PropTypes.string,
  to: PropTypes.any /* assignee */
  , id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  deactivateField: PropTypes.func,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  reviewInputLinkValue: PropTypes.string,
  review: PropTypes.object,
  defaultContacts: PropTypes.array.isRequired
};
Reviewer.defaultProps = {
  value: []
};


export default Reviewer;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Reviewer/index.js
// module id = 501
// module chunks = 0